import {
  IntegrityMonitorEventsActionsTaken,
  IntegrityMonitorEventsChanges,
} from '../../integrityMonitorEventsGrid/types';
import { IntegrityMonitorSeverity } from '../../../common/utils/types';

export interface IntegrityMonitorEventsPanelConfig {
  event_time: number;
  endpoint_id: string;
  endpoint_name: string;
  hostname: string;
  rule_name: string;
  change_type: string;
  severity: IntegrityMonitorSeverity;
  entity_type: string;
  mitre_ids: Array<string>;
  key: string;
  user: string;
  changes: IntegrityMonitorEventsChanges;
  category: string;
  actions_result: Array<IntegrityMonitorEventsActionsTaken>;
}

export enum IntegrityMonitorAttributeChangesStartType {
  BOOT,
  SYSTEM,
  AUTOLOAD,
  MANUAL,
  DISABLED,
}

export function getImAttributeChangesStartTypeMapping(translateFn: Function) {
  return {
    [IntegrityMonitorAttributeChangesStartType.BOOT]: translateFn('Boot'),
    [IntegrityMonitorAttributeChangesStartType.SYSTEM]: translateFn('System'),
    [IntegrityMonitorAttributeChangesStartType.AUTOLOAD]: translateFn('Autoload'),
    [IntegrityMonitorAttributeChangesStartType.MANUAL]: translateFn('Manual'),
    [IntegrityMonitorAttributeChangesStartType.DISABLED]: translateFn('Disabled'),
  };
}

export enum IntegrityMonitorAttributeChangesStatus {
  NONE,
  RUNNING,
  STOPPED,
}

export function getImAttributeChangesStatusMapping(translateFn: Function) {
  return {
    [IntegrityMonitorAttributeChangesStatus.NONE]: translateFn('None'),
    [IntegrityMonitorAttributeChangesStatus.RUNNING]: translateFn('Running'),
    [IntegrityMonitorAttributeChangesStatus.STOPPED]: translateFn('Stopped'),
  };
}
